import type { SVGProps } from "react";
export interface TranslateSquareIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function TranslateSquareIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: TranslateSquareIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M19.875 6c0-1.036-.84-1.875-1.875-1.875H6c-1.036 0-1.875.84-1.875 1.875v12c0 1.035.84 1.875 1.875 1.875h12c1.035 0 1.875-.84 1.875-1.875zm2.25 12A4.125 4.125 0 0 1 18 22.125H6A4.125 4.125 0 0 1 1.875 18V6A4.125 4.125 0 0 1 6 1.875h12A4.125 4.125 0 0 1 22.125 6z"
      />
      <path
        fill={color}
        d="M14.382 9.79a1.73 1.73 0 0 1 1.236 0l.195.089.163.101c.354.256.53.626.613.81.12.262.242.608.374.976l2.096 5.856.034.111a1.125 1.125 0 0 1-2.108.753l-.044-.105-.45-1.256H13.51l-.45 1.256a1.125 1.125 0 0 1-2.118-.759l2.096-5.856.192-.528c.062-.165.122-.317.182-.448.096-.21.311-.663.776-.911l.195-.09ZM9.5 4.875c.579 0 1.055.438 1.117 1H13a1.125 1.125 0 0 1 0 2.25h-.543a12 12 0 0 1-1.57 3.689q.172.11.325.188a1.126 1.126 0 0 1-1.006 2.012 6 6 0 0 1-.727-.433c-.86.88-1.86 1.617-2.977 2.175a1.125 1.125 0 1 1-1.004-2.013 8.8 8.8 0 0 0 2.285-1.646 8.7 8.7 0 0 1-1.105-1.455l-.186-.341-.045-.106a1.124 1.124 0 0 1 2.004-.997l.057.1.118.22c.144.24.336.502.559.768a9.8 9.8 0 0 0 .943-2.16H6a1.125 1.125 0 0 1 0-2.25h2.382c.062-.563.539-1 1.118-1.001m4.813 10h1.374L15 12.959l-.687 1.918Z"
      />
    </svg>
  );
}
